import accountRouters from './modules/account'
import designerAccountRouter from './modules/designerAccount'
import distributorAccountRouter from './modules/distributorAccount'
import storeAccountRouter from './modules/storeAccount'
export default [
  // 账号管理
  accountRouters,
  distributorAccountRouter,
  storeAccountRouter,
  designerAccountRouter
]
